import css from './OrderCardItem.module.scss'
import ImagePlaceholder from '../atoms/ImagePlaceholder'

export default function OrderCardItem({
	photo,
	name,
	actualPrice,
	// status,
	quantity = 1,
	storeCategory,
	addons,
}) {
	let fallbackIcon = 'fa fa-tag'
	return (
		<div className={css['box']}>
			<ImagePlaceholder
				src={photo}
				size='44px'
				iconName={fallbackIcon}
				className={css.photo}
			/>
			<div className={css['contents']}>
				<div className={css.title}>
					<span
						className={css['name']}
						title={name}>
						{`${name} (×${quantity})`}
					</span>
					<span
						className={css['price']}
						// title={`$${actualPrice} = $${actualPrice}`}
					>
						${parseFloat(actualPrice).toFixed(2)}
					</span>
				</div>

				<ul className={css['addons']}>
					{addons?.map(addon => (
						<li
							key={addon.name}
							className={css.addon}>
							+ {addon.name}
							<span>
								{addon.price > 0
									? `$${parseFloat(addon.price).toFixed(2)}`
									: 'Free'}
							</span>
						</li>
					))}
				</ul>
			</div>
		</div>
	)
}
